import React, {useRef, useCallback} from 'react';
import {useNavigate} from 'react-router-dom';
import {useTranslation} from 'react-i18next';

const TYPE_LABELS = { draw: '✏️', guess: '❓', compete: '🏆' };

export default function RoomCard({id, userCount, maxUsers, thumbnail, gameType, wordSets, customWordsName}) {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const isFull = maxUsers > 0 && userCount >= maxUsers;
    const cardRef = useRef(null);
    const shineRef = useRef(null);

    const handleMouseMove = useCallback((e) => {
        const card = cardRef.current;
        if (!card) return;
        const rect = card.getBoundingClientRect();
        const x = (e.clientX - rect.left) / rect.width;   // 0..1
        const y = (e.clientY - rect.top) / rect.height;    // 0..1
        const rotateY = (x - 0.5) * 14;   // ±7 deg
        const rotateX = (0.5 - y) * 10;   // ±5 deg
        card.style.transform = `rotateX(${rotateX}deg) rotateY(${rotateY}deg) translateY(-4px)`;
        if (shineRef.current) {
            shineRef.current.style.setProperty('--shine-x', `${x * 100}%`);
            shineRef.current.style.setProperty('--shine-y', `${y * 100}%`);
        }
    }, []);

    const handleMouseLeave = useCallback(() => {
        const card = cardRef.current;
        if (!card) return;
        card.style.transform = '';
    }, []);

    const isEmpty = userCount === 0;
    const wordsetLabel = (gameType === 'guess' && wordSets && wordSets.length > 0)
        ? wordSets.map(ws => {
            if (ws === '__custom__') return ((customWordsName || 'Custom') + ' (custom)');
            const i = ws.lastIndexOf('/');
            return i >= 0 ? ws.slice(i + 1) : ws;
        }).join(', ')
        : null;

    return (
        <div className="RoomCard-wrapper">
        <div className={'RoomCard' + (isEmpty ? ' is-empty' : '')} ref={cardRef}
             onClick={() => navigate('/room/' + id + (gameType ? '?game=' + gameType : ''))}
             onMouseMove={handleMouseMove}
             onMouseLeave={handleMouseLeave}
        >
            <div className="RoomCard-shine" ref={shineRef} />
            <div className="RoomCard-thumbnail">
                {thumbnail
                    ? <img src={thumbnail} alt={id + ' preview'} />
                    : <span className="RoomCard-placeholder">{t('roomCard.noPreview')}</span>
                }
                <span className="RoomCard-code">{id}</span>
                {gameType && gameType !== 'draw' && (
                    <span className="RoomCard-badge" title={gameType}>{TYPE_LABELS[gameType] || gameType}</span>
                )}
                {!isEmpty && <span className="RoomCard-live" title="Live"><span className="RoomCard-live-dot" />LIVE</span>}
            </div>
            <div className="RoomCard-info">
                <div className="RoomCard-info-main">
                    <span className="RoomCard-users" style={isFull ? {color: '#e55'} : undefined}>
                        {userCount}{maxUsers > 0 ? '/' + maxUsers : ''} {userCount === 1 && !maxUsers ? t('roomCard.user') : t('roomCard.users')}
                    </span>
                    {wordsetLabel && (
                        <span className="RoomCard-wordset" title={wordsetLabel}>{wordsetLabel}</span>
                    )}
                </div>
            </div>
        </div>
        </div>
    );
}
